<section>
    <h1>{{'PERMISSIONS.ACCESS_RESTRICTED' | translate}}</h1>
    <div class="image-container">
        <img [src]="'assets/images/access-denied/'+(currentTheme === 'super_admin' ? CssThemes.MODDAKIR : currentTheme)+'.png'" alt="access-denied">
    </div>
    <div class="page-text">
        <p>{{'PERMISSIONS.ACCESS_RESTRICTED_MSG' | translate}}</p>
    </div>
</section>